<template>
  <div
    id="item-lista"
    :style="estiloCss"
    :class="classesCss"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "ItemLista",
  props: {
    height: [Number, String],
    ativo: Boolean
  },
  computed: {
    estiloCss() {
      return {
        minHeight: `${this.height}px`
      }
    },
    classesCss() {
      return {
        ativo: this.ativo
      }
    }
  }
}
</script>

<style scoped>
p {
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.6);
}
#item-lista {
  border-bottom: 1px solid #e8e5e5;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
}
#item-lista:hover {
  background: #F1F7FF;
}
.coluna-principal {
  font-weight: 700;
  font-size: 14px;
  line-height: 22px;
  color: #333333;
}
.titulo-informacao {
  font-size: 14px;
  line-height: 16px;
  font-weight: 500;
}
.ativo {
  background: #F1F7FF;
}
.informacao {
  font-size: 12px;
  line-height: 16px;
}
.informacao .descricao {
  font-weight: 700;
  line-height: 16px;
}
</style>
